
import Vue from "vue";
import { Component, Inject, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import { DynamicFieldOutput } from "@/types/dynamic-data";
import DynamicDataFieldAttributes from "@/components/Reusable/ControlsTree/DynamicData/DynamicDataFieldAttributes.vue";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { Control, ControlsTreeContext } from "@/types/controls";
import { getShortcodeFromDynamicField } from "@/lib/dynamic-data/utils";

@Component({
  components: { Icon, DynamicDataFieldAttributes, Dropdown }
})
export default class DynamicInput extends Vue {
  @Inject("context") readonly context!: ControlsTreeContext;

  @Prop()
  control!: Control;

  @Prop()
  value: any;

  @Prop()
  meta?: DynamicFieldOutput | null;

  @Prop({ default: 10 })
  iconSize!: number;

  get dynamicField() {
    return this.meta?.field;
  }

  get dynamicAttributes() {
    return this.meta?.attributes;
  }

  cancelDynamic() {
    this.$emit("clear", "");
  }

  setAttributeValue(value: DynamicFieldOutput) {
    if (!this.dynamicField) {
      return;
    }
    const shortcode = getShortcodeFromDynamicField(value, this.dynamicField);
    this.$emit("input", shortcode);
    this.$emit("change", {
      field: this.dynamicField,
      shortcode,
      attributes: value
    });
  }

  attributesDialogOpen = false;
  setAttributesDialog() {
    this.attributesDialogOpen = !this.attributesDialogOpen;
  }

  get position() {
    return {
      left: true,
      bottom: true,
      offsetY: true
    };
  }

  get title() {
    return this.dynamicField?.label
      ? `${this.dynamicField.label} Options`
      : "Options";
  }
}
